import axios from "axios";
import {
  createActionErrorCapture,
  errorEnvelope,
} from "../../../../utils/sentryUtils";
import {
  getToken,
  getTokenHeader,
  getTokenHeaderFile,
} from "../../../Common/Token";
import {
  addDistributorSellInvoiceUrl,
  getCompanyWiseInventoryDataUrl,
  getProductWiseinventoryDataUrl,
  getUserInventoryTransactionsStpInfoUrl,
} from "../urls";

// PWA-reachable module: capture at the action layer so failures carry a stack
// trace and an error kind, not just a message string from the call site.
const captureActionError = createActionErrorCapture('inventory');

export const GetCompanyWiseInventoryData = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getCompanyWiseInventoryDataUrl()}?company_esi_id=${company_esi_id}`,
        getTokenHeaderFile(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'GetCompanyWiseInventoryData');
        return next(errorEnvelope(err));
      });
  });
};

export const GetProductWiseinventoryData = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getProductWiseinventoryDataUrl()}`, {
        ...getTokenHeaderFile(token),
        params: data,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'GetProductWiseinventoryData');
        return next(errorEnvelope(err));
      });
  });
};

export const AddDistributorSellInvoice = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${addDistributorSellInvoiceUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'AddDistributorSellInvoice');
        return next(errorEnvelope(err));
      });
  });
};

export const getUserInventoryTransactionsStpInfoAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        getUserInventoryTransactionsStpInfoUrl(),
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getUserInventoryTransactionsStpInfoAction');
        return next(errorEnvelope(err));
      });
  });
};
